'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const ClaraWidget = dynamic(() => import('./ClaraWidget'), {
  ssr: false,
  loading: () => null,
});

export default function ClaraWidgetClient() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const loadWidget = () => setMounted(true);

    if (typeof window === 'undefined') return;

    const timeoutId = window.setTimeout(loadWidget, 1200);
    const handleInteraction = () => {
      loadWidget();
      window.removeEventListener('pointerdown', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
    };

    window.addEventListener('pointerdown', handleInteraction, { once: true });
    window.addEventListener('keydown', handleInteraction, { once: true });

    return () => {
      window.clearTimeout(timeoutId);
      window.removeEventListener('pointerdown', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
    };
  }, []);

  if (!mounted) {
    return null;
  }

  return <ClaraWidget data-component-id="src/app/components/ClaraWidgetClient.tsx:40:9" data-component-path="src/app/components/ClaraWidgetClient.tsx" data-component-line="40" data-component-end-line="40" data-component-file="ClaraWidgetClient.tsx" data-component-name="ClaraWidget" data-component-content="%7B%22elementName%22%3A%22ClaraWidget%22%7D" />;
}
